import * as React from "react"
import { Fragment } from "react"
import { Popover, Transition } from "@headlessui/react"
import { MenuIcon, XIcon } from "@heroicons/react/outline"
import Logo from "../images/eh_logo.svg"
import "../styles/home.css"
import { Link } from "gatsby"
import Github from "../images/github.svg"

export default function Header() {
  return (
    <Popover className="relative bg-white rounded-lg mx-auto mt-4 head-style ethan-width">
      <div className="mx-auto py-1 px-4 sm:px-6 ">
        <div className="flex justify-between items-center md:justify-start md:space-x-10">
          <div className="flex justify-start lg:w-0 lg:flex-1">
            <Link to="/">
              <span className="sr-only">Workflow</span>
              <img className="h-20 w-auto" src={Logo} alt="" />
            </Link>
          </div>
          <div className="-mr-2 -my-2 md:hidden">
            <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
              <span className="sr-only">Open menu</span>
              <MenuIcon className="h-6 w-6" aria-hidden="true" />
            </Popover.Button>
          </div>
          <Popover.Group as="nav" className="hidden md:flex space-x-10">
            <Link
              to="/contact"
              className="text-base font-medium text-gray-500 ethan-hover px-0.5 hover:from-gray-800"
            >
              Let's Chat
            </Link>
            <a
              href="https://github.com/ethan9000"
              target="_blank"
              className="text-base font-medium text-gray-500 ethan-hover px-0.5 hover:from-gray-800 margin-fix"
            >
              <img src={Github} alt="Github" />
            </a>
          </Popover.Group>
        </div>
      </div>

      <Transition
        as={Fragment}
        enter="duration-200 ease-out"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="duration-100 ease-in"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <Popover.Panel
          focus
          className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden"
        >
          <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
            <div className="pt-5 pb-6 px-5">
              <div className="flex items-center justify-between">
                <div>
                  <img className="h-20 w-auto" src={Logo} alt="Workflow" />
                </div>
                <div className="-mr-2">
                  <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                    <span className="sr-only">Close menu</span>
                    <XIcon className="h-6 w-6" aria-hidden="true" />
                  </Popover.Button>
                </div>
              </div>
            </div>
            <div className="py-6 px-5 space-y-6">
              <div className="grid grid-cols-1 gap-y-4 gap-x-8">
                {/* <a href="#" className="text-base font-medium text-gray-900 hover:text-gray-700">
                  About Me
                </a> */}
                <Link
                  to="/contact"
                  className="text-base font-medium text-gray-500 ethan-hover px-0.5 hover:from-gray-800"
                >
                  Let's Chat
                </Link>
                <a
                  href="https://github.com/ethan9000"
                  target="_blank"
                  className="text-base font-medium text-gray-500 ethan-hover px-0.5 hover:from-gray-800 margin-fix"
                >
                  <img src={Github} alt="Github" />
                </a>
              </div>
            </div>
          </div>
        </Popover.Panel>
      </Transition>
    </Popover>
  )
}
